import * as yup from 'yup';

export enum GroupSubtypeEnum {
  enterprise = 'enterprise',
  municipal = 'municipal',
  municipal_closed = 'municipal_closed',
  education = 'education',
  realestate = 'realestate',
}

export enum PlanRecurrenceEnum {
  no = 'no',
  monthly = 'monthly',
  yearly = 'yearly',
}

export const planSchema = yup.object({
  id: yup.string().uuid().required(),
  createdAt: yup.string().required(),
  expiresAt: yup.string().nullable().defined(),
  recurrence: yup.mixed<PlanRecurrenceEnum>().oneOf(Object.values(PlanRecurrenceEnum)).required(),
  code: yup.object({
    code: yup.string().required(),
    name: yup.string().required(),
    group: yup
      .object({
        id: yup.string().required(),
        name: yup.string().required(),
        type: yup.string().required(),
        subtype: yup.mixed<GroupSubtypeEnum>().oneOf(Object.values(GroupSubtypeEnum)).required(),
        allowMembersListing: yup.boolean().optional(),
        picture: yup.string().optional(),
      })
      .optional()
      .default(undefined),
  }),
});
